import { FormControl } from "./FormControl"

export class FormManager {
  static with = (form, propertyName, valueFunc) => {
    let formCopy = { ...form }
    const names = Object.keys(formCopy)

    names.forEach((name) => {
      const control = form[name]
      formCopy = {
        ...formCopy,
        [name]: { ...control, [propertyName]: valueFunc(control) },
      }
    })

    return formCopy
  }

  static disableForm = (form) => {
    const formCopy = FormManager.with(form, "disabled", (control) => true)
    console.log("disabled form", formCopy)
    return formCopy
  }

  static validateRequiredFields = (form) => {
    const formCopy = FormManager.with(
      form,
      "hasError",
      (control) =>
        JSON.stringify(control.value) ===
          JSON.stringify(control.defaultValue) &&
        control.required &&
        !control.disabled
    )
    console.log("validated form", formCopy)
    return formCopy
  }

  static clearErrors = (form) =>
    FormManager.with(form, "hasError", (control) => false)

  static formHasErrors = (form) => {
    const names = Object.keys(form)
    let hasError = false
    names.forEach((name) => {
      const control = form[name]
      if (control.hasError) hasError = true
    })

    return hasError
  }

  static initializeForm = (reviewer) => {
    return {
      reviewer: FormManager.createRequiredControl("").withValue(reviewer),
      compliantSelection: FormManager.createRequiredControl(""),
      nonComplianceType: FormManager.createRequiredControl(""),
      notifiedDate: FormManager.createOptionalControl(""),
      a1: FormManager.createRequiredControl(""),
      a2: FormManager.createRequiredControl(""),
      a2date: FormManager.createOptionalControl(""),
      a3: FormManager.createRequiredControl(""),
      a4: FormManager.createOptionalControl([]),
      a5: FormManager.createOptionalControl(""),
      a6: FormManager.createOptionalControl(""),
      c1: FormManager.createRequiredControl(""),
      c2: FormManager.createRequiredControlWithDisabledValue("", "N/A"),
      c2date: FormManager.createOptionalControl("").withResetValueOnEnable(
        false
      ),
      c3: FormManager.createRequiredControlWithDisabledValue("", "N/A"),
      c3date: FormManager.createOptionalControl(""),
      c4: FormManager.createRequiredControlWithDisabledValue("", "N/A"),
      q8: FormManager.createRequiredControl(""),
      q8date: FormManager.createOptionalControl(""),
      q9: FormManager.createRequiredControlWithDisabledValue("", "N/A"),
      q9date: FormManager.createOptionalControl(""),
      q10: FormManager.createRequiredControlWithDisabledValue("", "N/A"),
      q10date: FormManager.createOptionalControl(""),
      q11: FormManager.createRequiredControlWithDisabledValue("", "N/A"),
      q11date: FormManager.createOptionalControl(""),
      q12: FormManager.createRequiredControlWithDisabledValue([], "N/A"),
      q12date: FormManager.createOptionalControl(""),
      q13: FormManager.createRequiredControlWithDisabledValue("", "N/A"),
      q13date: FormManager.createOptionalControl(""),
      q14: FormManager.createRequiredControlWithDisabledValue("", "N/A"),
      q14date: FormManager.createOptionalControl(""),
      q15: FormManager.createRequiredControlWithDisabledValue("", "N/A"),
      q15date: FormManager.createOptionalControl(""),
      q16: FormManager.createRequiredControlWithDisabledValue("", "N/A"),
      q16date: FormManager.createOptionalControl(""),
      q17: FormManager.createRequiredControlWithDisabledValue("", "N/A"),
      q17date: FormManager.createOptionalControl(""),
      nonCompliantIndicator: FormManager.createOptionalControl(""),
      findingsActions: FormManager.createOptionalControl(""),
      nonCompliantReasons: FormManager.createOptionalControl([]),
      notes: FormManager.createOptionalControl(""),
    }
  }

  static initializeIrrForm = () => {
    return {
      q1: FormManager.createOptionalControl(""),
      q2: FormManager.createOptionalControl(""),
      q3: FormManager.createOptionalControl(""),
      q4: FormManager.createOptionalControl(""),
      q5: FormManager.createOptionalControl(""),
      comment: FormManager.createOptionalControl(""),
    }
  }

  static patchIrrForm = (irrReview) => {
    return {
      q1: FormManager.createOptionalControl(irrReview.q1),
      q2: FormManager.createOptionalControl(irrReview.q2),
      q3: FormManager.createOptionalControl(irrReview.q3),
      q4: FormManager.createOptionalControl(irrReview.q4),
      q5: FormManager.createOptionalControl(irrReview.q5),
      comment: FormManager.createOptionalControl(irrReview.comment),
    }
  }

  static createRequiredControl = (defaultValue) =>
    new FormControl(defaultValue, false, true, defaultValue, null)

  static createRequiredControlWithDisabledValue = (
    defaultValue,
    disabledValue
  ) => new FormControl(defaultValue, false, true, defaultValue, disabledValue)

  static createOptionalControl = (defaultValue) =>
    new FormControl(defaultValue, false, false, defaultValue)

  static onChange = (name, value, form) => {
    let control = form[name]

    let formCopy = {
      ...form,
      [name]: {
        ...control,
        value,
        hasError:
          value === control.defaultValue &&
          control.required &&
          !control.disabled,
      },
    }

    const toggle = (originalValue, targets) =>
      FormManager.toggleOnNa(value, formCopy)(originalValue, targets, targets)
    // const asymmetricalToggleOnNa = (disableTargets, enableTargets) => FormManager.toggleOnNa(value, formCopy)(disableTargets, enableTargets);
    switch (name) {
      case "a2":
        return FormManager.toggleRequire(value, ["a2date"], formCopy, "yes")
      case "c1":
        return toggle(form[name].value, ["c2", "c2date", "c3", "c3date", "c4"])
      case "c2":
      case "c3":
      case "q8":
      case "q9":
      case "q10":
      case "q11":
      case "q13":
      case "q14":
      case "q15":
      case "q16":
      case "q17":
        return toggle(form[name].value, [`${name}date`])
      case "q12":
        return toggle(form[name].value, [
          "q12date",
          "q13",
          "q13date",
          "q14",
          "q14date",
          "q15",
          "q15date",
          "q16",
          "q16date",
          "q17",
          "q17date",
        ])
      case "compliantSelection":
        return FormManager.toggleOnChange(
          value,
          formCopy,
          ["nonComplianceType"],
          "yes",
          ["nonComplianceType"],
          form[name].value
        )
      default:
        return formCopy
    }
  }

  static onIrrFormChange = (name, value, form) => {
    let control = form[name]

    let formCopy = {
      ...form,
      [name]: {
        ...control,
        value,
        hasError:
          value === control.defaultValue &&
          control.required &&
          !control.disabled,
      },
    }

    return formCopy
  }

  static toggleOnNa = (value, form) => (
    originalValue,
    disableTargets,
    enableTargets
  ) =>
    FormManager.toggleOnChange(
      value,
      form,
      disableTargets,
      "N/A",
      enableTargets,
      originalValue
    )

  static toggleOnChange = (
    value,
    form,
    disableTargets,
    disableValue,
    enableTargets,
    originalValue
  ) => {
    if (!value) return form
    if (
      value === disableValue ||
      (Array.isArray(value) && value.includes(disableValue))
    ) {
      return FormManager.disableAndClear(disableTargets, form)
    } else if (
      originalValue === disableValue ||
      (Array.isArray(originalValue) && originalValue.includes(disableValue))
    ) {
      return FormManager.enableAndRequire(enableTargets, form)
    } else {
      return form
    }
  }

  static disableAndClear = (names, form) => {
    let formCopy = form
    names.forEach((name) => {
      let control = form[name]
      formCopy = {
        ...formCopy,
        [name]: {
          ...control,
          value: control.disabledValue
            ? control.disabledValue
            : control.defaultValue,
          disabled: true,
          hasError: false,
        },
      }
    })

    return formCopy
  }

  static enableAndRequire = (names, form) => {
    let formCopy = form
    names.forEach((name) => {
      let control = form[name]
      formCopy = {
        ...formCopy,
        [name]: {
          ...control,
          value: control.resetValueOnEnable
            ? control.defaultValue
            : control.value,
          disabled: false,
        },
      }
    })

    return formCopy
  }

  static toggleRequire = (value, names, form, requireValue) => {
    let formCopy = form
    names.forEach((name) => {
      let control = form[name]
      formCopy = {
        ...formCopy,
        [name]: {
          ...control,
          value: control.value,
          required: value === requireValue,
          disabled: false,
          hasError: false,
        },
      }
    })

    return formCopy
  }
}



// WEBPACK FOOTER //
// ./src/modules/record/components/forms/FormManager.js